import { FrontendLoad } from '@trucksmarter/shared';
import { DallasTableDataCell } from '~/app/_ui/Dallas/Table/DallasTable';
import { EMPTY_VALUE_PLACEHOLDER } from '~/app/_ui/shared/text-placeholders';
import DallasText from '~/app/_ui/Dallas/Text/DallasText';
import FormattedPounds from '~/app/_ui/shared/FormattedMeasurements/FormattedPounds';
import {
  toCommaSeparated,
  toCompact,
} from '../../../../../../../../utils/number';

function createPoundsFormatter(isCompact: boolean) {
  return function formatPounds(pounds: number) {
    return isCompact ? toCompact(pounds) : toCommaSeparated(pounds);
  };
}

interface Props {
  className?: string;
  load: FrontendLoad;
  compact?: boolean;
}

export default function DimensionsCell({ className, ...props }: Props) {
  return (
    <DallasTableDataCell className={className}>
      <DimensionsCellContent {...props} />
    </DallasTableDataCell>
  );
}

export function DimensionsCellContent({
  load,
  compact: isCompact = false,
}: Omit<Props, 'className'>) {
  return (
    <>
      {load.weight !== null ? (
        <FormattedPounds
          textVariant="captionL"
          measurement={load.weight}
          formatter={createPoundsFormatter(isCompact)}
        />
      ) : (
        <DallasText variant="captionL">{EMPTY_VALUE_PLACEHOLDER}</DallasText>
      )}
      <DallasText color="darkGray" variant="captionL" as="div">
        {load.equipment.length
          ? `${load.equipment.length}'`
          : EMPTY_VALUE_PLACEHOLDER}
      </DallasText>
    </>
  );
}
